import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, FormGroup } from "@mui/material";

//import constants
import { IS_MOBILE } from "../../../../constants/breakpoints";
import { LocaleContext } from "../../../../routing/LangRouter";

//import general components
import BaseFilter from "../../../common/base-filter/base-filter";
import BaseTextField from "../../../common/base-text-field/base-text-field";
import BaseCheckbox from "../../../common/base-checkbox/base-checkbox";

//import images and icons
import { ArrowDown2 } from "iconsax-react";

function TourFilter({ open, setOpen, defaultValue, filterList, setAppliedFilters }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //category names for filters
    const categoryName = {
        origin_countries: t("departureCountry"),
        destination_countries: t("destinationCountry"),
        origin_cities: t("departureCity"),
        destination_cities: t("destinationCity"),
        accommodations: t("hotel"),
        origin_airports: t("departureAirport"),
        destination_airports: t("destinationAirport"),
    };

    //initialize the filtered list when the filterList prop changes
    const [filteredOriginList, setFilteredOriginList] = useState();
    useEffect(() => {
        if (filterList) {
            setFilteredOriginList(filterList);
        }
    }, [filterList]);

    // Handle changes in the search input for filtering
    const handleSearchInputChange = event => {
        const { name, value } = event.target;
        const updatedFilteredList = value ? { [name]: filterList?.[name].filter(item => item?.name?.includes(value)) } : filterList;
        setFilteredOriginList(updatedFilteredList);
    };

    //handle changes in filter selection
    const [selectedFilters, setSelectedFilters] = useState({});
    const activeFilterCount = Object.keys(selectedFilters).length - 1 || "";
    const handleFilterChange = (event, category) => {
        const { name, checked } = event.target;
        const updatedFilters = {
            ...selectedFilters,
            [category]: { ...selectedFilters?.[category], [name]: checked },
        };
        // if (!checked) {
        //     delete updatedFilters[category];
        // }
        setSelectedFilters(updatedFilters);
        if (!IS_MOBILE) {
            setAppliedFilters(formatFiltersForSubmission(updatedFilters));
        }
    };

    // This function formats the selected filters for submission by converting the input object into a result object
    // where each category contains a comma-separated string of selected keys
    const formatFiltersForSubmission = input => {
        const result = {};
        Object.keys(input).forEach(category => {
            const selectedKeys = Object.keys(input[category]).filter(key => input[category][key] === true);
            result[category] = selectedKeys.join(",");
        });
        return result;
    };

    //this function handles the submission of filters on a mobile device.
    const handleSubmitFilter = () => {
        if (selectedFilters && IS_MOBILE) {
            setAppliedFilters(formatFiltersForSubmission(selectedFilters));
        }
    };

    //set default values for selected filters based on the provided defaultValue prop
    useEffect(() => {
        if (defaultValue) {
            const updatedFilters = Object.entries(defaultValue).reduce((acc, [filterName, value]) => {
                const filterObject = value.split(",").reduce((map, obj) => ({ ...map, [obj]: true }), {});
                acc[filterName] = filterObject;
                return acc;
            }, {});
            setSelectedFilters(updatedFilters);
        }
    }, [defaultValue]);

    //handle filter cancellation
    const resetFilters = () => {
        setAppliedFilters({});
    };

    return (
        <BaseFilter
            open={open}
            setOpen={setOpen}
            handleSubmitFilter={handleSubmitFilter}
            resetFilters={resetFilters}
            activeFilterCount={activeFilterCount}
            top="0"
        >
            {filterList &&
                Object.keys(filterList).map((filterKey, index) => {
                    return (
                        filterKey !== "keywords" && (
                            <Accordion
                                key={index}
                                sx={{ width: "100%", boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)", margin: " 0 !important" }}
                                defaultExpanded
                            >
                                <AccordionSummary expandIcon={<ArrowDown2 color="var(--gray-color)" />} sx={{ fontWeight: "700" }}>
                                    {categoryName?.[filterKey]}
                                </AccordionSummary>

                                <AccordionDetails sx={{ maxHeight: "20rem", overflowY: "scroll", "&::-webkit-scrollbar": { display: "none" } }}>
                                    <BaseTextField label={t("search")} size="small" name={filterKey} setValue={handleSearchInputChange} />
                                    {filteredOriginList?.[filterKey]?.map(filterItem => {
                                        return (
                                            <FormGroup className="base-filter__filter-label">
                                                <BaseCheckbox
                                                    label={
                                                        locale === "fa"
                                                            ? filterItem?.name || filterItem?.english_name
                                                            : filterItem?.english_name || filterItem?.name
                                                    }
                                                    name={filterItem.id}
                                                    checked={selectedFilters?.[filterKey]?.[filterItem.id] || false}
                                                    handleChange={handleFilterChange}
                                                    otherName={filterKey}
                                                />
                                            </FormGroup>
                                        );
                                    })}
                                </AccordionDetails>
                            </Accordion>
                        )
                    );
                })}
        </BaseFilter>
    );
}

export default TourFilter;
